import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the active "Review Shifts" button on the
 * "Shift Details" step of the NEW Shift Request flow
 * Event: dental_portal:shift_request:shift_details_submitted
 */
export function fireShiftDetailsSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:shift_details_submitted');
}
